import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import React, { ReactNode } from 'react'
import theme from '../../theme'

interface ProvidersProps {
  children: ReactNode
  withNotifications?: boolean
  notificationPosition?: 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center'
}

export const Providers = ({ 
  children, 
  withNotifications = true,
  notificationPosition = 'top-right'
}: ProvidersProps) => {
  return (
    <MantineProvider theme={theme} defaultColorScheme="auto">
      {children}
      {withNotifications && (
        <Notifications 
          position={notificationPosition}
          zIndex={9999}
          limit={5}
        />
      )}
    </MantineProvider>
  )
}

export type { ProvidersProps }
